import * as components from './components';

export default [
  {
    path: '/masters/parts',
    component: components.PartList,
    name: 'partList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/parts/routes.js